import { ROUTE_PATH_ADMIN } from '../../configRoutes';

export const ROUTE_PATH_SUPPORT_TICKETS = ROUTE_PATH_ADMIN + '/support-tickets';
export const ROUTE_PATH_SUPPORT_TICKET = ROUTE_PATH_ADMIN + '/support-tickets/:supportTicketsId';

export const getSupportTicketPathById = (supportTicket: string) => `${ROUTE_PATH_SUPPORT_TICKETS}/${supportTicket}`;

export const getSupportTicketsListWithPaginationPath = ({ page, size }: { page: string; size: string }) =>
  `${ROUTE_PATH_ADMIN}/support-tickets?page=${page}&size=${size}`;
